module.exports = __webpack_public_path__ + "img/foot_logo.19f44010.png";